import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Newspaper } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import { commercialRealEstateAllNews } from "@/data/commercialRealEstateAllNews";

const CommercialRealEstateNewsPage = () => {
  const { slug } = useParams();
  const article = commercialRealEstateAllNews.find((item) => item.slug === slug);

  if (!article) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <main className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-4 text-center">
          <p className="text-xs font-black uppercase tracking-wide text-[#0056D2]">Noticias</p>
          <h1 className="mt-2 text-3xl font-black text-slate-950">Nota no encontrada</h1>
          <Link
            to="/#noticias"
            className="mt-6 inline-flex items-center gap-2 rounded-lg bg-[#0056D2] px-5 py-3 text-sm font-black text-white"
          >
            <ArrowLeft className="h-4 w-4" />
            Regresar
          </Link>
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <article className="mx-auto max-w-4xl px-4 py-8 sm:py-12">
          <Link
            to="/#noticias"
            className="inline-flex items-center gap-2 text-sm font-black text-[#0056D2] transition hover:text-blue-700"
          >
            <ArrowLeft className="h-4 w-4" />
            Regresar
          </Link>

          <div className="mt-6 overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm">
            <div className={`relative h-56 bg-gradient-to-r ${article.accent} sm:h-72`}>
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_20%,rgba(255,255,255,0.30),transparent_28%),linear-gradient(135deg,rgba(255,255,255,0.18),transparent_48%)]" />
              <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between gap-3">
                <span className="rounded-sm border border-white/40 bg-white/95 px-3 py-1 text-xs font-black uppercase text-slate-950 shadow-sm">
                  {article.tag}
                </span>
                <span className="hidden items-center gap-2 rounded-sm border border-white/30 bg-white/15 px-3 py-1 text-xs font-black uppercase text-white backdrop-blur sm:inline-flex">
                  <Newspaper className="h-4 w-4" />
                  Tulocalmx te informa
                </span>
              </div>
            </div>

            <div className="p-5 sm:p-8">
              <p className="text-xs font-black uppercase tracking-wide text-[#F97316]">
                Fuente: {article.sourceName}
              </p>
              <h1 className="mt-3 text-3xl font-black leading-tight text-slate-950 sm:text-5xl">
                {article.title}
              </h1>

              <p className="mt-5 text-lg font-semibold leading-8 text-slate-700">
                {article.summary}
              </p>

              <section className="mt-8 border-t border-slate-100 pt-6">
                <h2 className="text-xl font-black text-slate-950">Lo más importante</h2>
                <p className="mt-3 text-base leading-8 text-slate-700">{article.highlight}</p>
              </section>

              <section className="mt-8 space-y-5">
                {(article.body || []).map((paragraph) => (
                  <p key={paragraph} className="text-base leading-8 text-slate-700">
                    {paragraph}
                  </p>
                ))}
              </section>

              <section className="mt-8 rounded-md border border-slate-200 bg-slate-50 p-5">
                <h2 className="text-lg font-black text-slate-950">Datos clave</h2>
                <ul className="mt-4 grid gap-3 sm:grid-cols-2">
                  {(article.keyPoints || []).map((point) => (
                    <li key={point} className="rounded-md border border-slate-200 bg-white p-3 text-sm font-semibold leading-6 text-slate-700">
                      {point}
                    </li>
                  ))}
                </ul>
              </section>

              <div className="mt-8 border-t border-slate-100 pt-5">
                <p className="text-sm font-semibold leading-7 text-slate-500">
                  Referencia original: {article.source}
                </p>
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default CommercialRealEstateNewsPage;
